import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function OrthopaedicEvaluation() {
  useEffect(() => {
    document.title = "Orthopaedic Evaluation & Diagnosis | Viksha Health Care";
    const newMetaDescription =
      "Evaluation and diagnosis of bone, joint, muscle and ligament problems at Viksha Health Care. Understand the cause and choose the right treatment.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/orthopaedicEvaluation.avif" />
        </div>
        <div className="textareaofser">
          <h1>
            Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament
            Problems
          </h1>

          <p>
            Accurate evaluation and diagnosis are the first and most important
            steps in treating orthopaedic conditions. Problems involving bones,
            joints, muscles, and ligaments can cause pain, swelling, stiffness,
            or reduced movement. A detailed assessment helps identify the exact
            cause and guides the most suitable treatment.
          </p>

          <p>
            Early and precise diagnosis not only relieves current symptoms but
            also prevents long-term damage and complications.
          </p>

          <h5>Comprehensive Clinical Assessment</h5>

          <h6>Symptom Review</h6>
          <p>
            The evaluation begins with understanding your symptoms, including
            when they started, how severe they are, and what activities make
            them better or worse. Your medical history, occupation, and activity
            level are also considered.
          </p>

          <h6>Physical Examination</h6>
          <p>
            A focused physical examination helps assess joint movement, muscle
            strength, tenderness, swelling, and alignment. Gait (walking
            pattern) and posture may also be evaluated to identify underlying
            issues.
          </p>

          <h5>Diagnostic Tests (When Needed)</h5>
          <p>
            In some cases, clinical examination alone is not enough. Diagnostic
            tests may be recommended to confirm the diagnosis and understand the
            extent of the problem.
          </p>

          <ul>
            <li>X-rays to assess bone structure and joint alignment</li>
            <li>Imaging studies for soft tissue or ligament concerns</li>
            <li>
              Laboratory tests when inflammatory or systemic conditions are
              suspected
            </li>
          </ul>

          <h5>Common Conditions Evaluated</h5>
          <ul>
            <li>Joint pain and stiffness</li>
            <li>Muscle strains and weakness</li>
            <li>Ligament injuries and sprains</li>
            <li>Back and neck pain</li>
            <li>Sports injuries</li>
            <li>Fractures and trauma-related issues</li>
          </ul>

          <h5>Importance of Early Diagnosis</h5>
          <p>
            Ignoring musculoskeletal symptoms may lead to worsening pain and
            joint damage. Early diagnosis allows timely treatment, faster
            recovery, and better long-term outcomes.
          </p>

          <h5>Personalized Treatment Planning</h5>
          <p>
            Once the diagnosis is confirmed, a tailored treatment plan is
            discussed. This may include medications, physiotherapy, lifestyle
            changes, supportive devices, or procedures depending on the
            condition and severity.
          </p>

          <h5>When to Seek Evaluation</h5>
          <ul>
            <li>Pain lasting more than a few days</li>
            <li>Swelling or stiffness in joints</li>
            <li>Difficulty moving or using a limb</li>
            <li>Pain after injury, fall, or sports activity</li>
            <li>Numbness, weakness, or reduced strength</li>
          </ul>

          <p>
            If you are experiencing ongoing discomfort in bones, joints,
            muscles, or ligaments, a thorough orthopaedic evaluation can help
            identify the cause and guide effective treatment so you can return
            to your normal activities with confidence.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(OrthopaedicEvaluation);
